import { render, staticRenderFns } from "./kardex.vue?vue&type=template&id=451c22b3&"
import script from "./kardex.vue?vue&type=script&lang=js&"
export * from "./kardex.vue?vue&type=script&lang=js&"
import style0 from "./kardex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports